import {
  EventBridgeClient,
  PutEventsCommand,
} from '@aws-sdk/client-eventbridge'
import { WorkadayEvent } from '../../events/app/base'
import { ChargeEventSchema } from '../../events/app/chargeEvent'
import { customerReviewEventSchema } from '../../events/app/customerReviewEvent'
import { JobAuctionEventSchema } from '../../events/app/jobAuctionEvent'
import {
  jobAwardedEventSchema,
  jobEventSchema,
} from '../../events/app/jobEvent'
import { JobMessageEventSchema } from '../../events/app/jobMessageEvent'
import { notificationEventSchema } from '../../events/app/notificationEvent'
import { PaymentEventSchema } from '../../events/app/paymentEvent'

const client = new EventBridgeClient({ region: process.env.AWS_REGION })

export enum EventSourceTypes {
  Job = 'job',
  Charge = 'charge',
  Payment = 'payment',
  Notification = 'notification',
  Review = 'review',
  Auction = 'auction',
  Websocket = 'websocket',
}

export enum WorkadayEventTypes {
  CustomerReview = 'CustomerReview',
  JobMessage = 'JobMessage',
  JobCreated = 'CreatedJob',
  JobCanceled = 'CancelJob',
  JobAuction = 'JobAuction',
  ScheduleRequest = 'ScheduleRequest',
  JobAwarded = 'AwardedJob',
  JobAuctionExpired = 'AuctionExpired',
  PaymentFailed = 'failed',
  PaymentSuccessful = 'succeeded',
  DebitCharge = 'Debit',
}

export enum WorkadaySourceTypes {
  SourceJob = `Workaday.Job`,
  SourceCustomerReview = `Workaday.Customer.Review`,
  SourceAuction = `Workaday.Auction`,
  SourceUser = `Workaday.User`,
  SourcePayment = `Workaday.Payments`,
  SourceNotification = `Workaday.Notifications`,
}

export const publishEvent = async (
  event: WorkadayEvent,
  eventType: WorkadayEventTypes,
  source: EventSourceTypes,
) => {
  const publishableEvent = {
    Entries: [
      {
        Time: new Date(),
        Source: `${process.env.APP_NAME}.${source}`,
        DetailType: eventType,
        Detail: validateEventByType(event, eventType),
        EventBusName: process.env.EVENT_BUS_NAME,
      },
    ],
  }
  const command = new PutEventsCommand(publishableEvent)
  await client.send(command)
}

const validateEventByType = (
  event: WorkadayEvent,
  eventType: WorkadayEventTypes,
) => {
  let detail
  switch (eventType) {
    case WorkadayEventTypes.CustomerReview:
      detail = { ...customerReviewEventSchema.parse(event) }
      break
    case WorkadayEventTypes.JobMessage:
      detail = { ...JobMessageEventSchema.parse(event) }
      break
    case WorkadayEventTypes.JobCanceled:
    case WorkadayEventTypes.JobCreated:
      detail = { ...jobEventSchema.parse(event) }
      break
    case WorkadayEventTypes.ScheduleRequest:
      detail = { ...notificationEventSchema.parse(event) }
      break
    case WorkadayEventTypes.JobAuction:
      detail = { ...JobAuctionEventSchema.parse(event) }
      break
    case WorkadayEventTypes.JobAwarded:
    case WorkadayEventTypes.JobAuctionExpired:
      detail = { ...jobAwardedEventSchema.parse(event) }
      break
    case WorkadayEventTypes.PaymentFailed:
    case WorkadayEventTypes.PaymentSuccessful:
      detail = { ...PaymentEventSchema.parse(event) }
      break
    case WorkadayEventTypes.DebitCharge:
      detail = { ...ChargeEventSchema.parse(event) }
      break
    default:
      throw new Error('Event type not defined')
  }
  return JSON.stringify(detail)
}
